/**
 * Created by 唐亦慧 on 2017/8/29.
 */
import {config, request, objectSerial} from 'Utils';

//获取分类列表
export function categoryList(param) {
	return request(`${config.server}/api/v1/dms/category/list`,{
		method: 'post',
		body: param
	});
}

/*获取子库列表*/
export function getSubStoreList(param) {
	return request(`${config.server}/api/v1/dms/dmsTianSubStore/listByPage`, {
	  method: 'post',
	  body: {...param},
	});
  }

export function productAync() {
	return request(`${config.server}/api/v1/dms/syncTgOrder/category`);
}
//修改分类
/*
 * {
 active (integer, optional): 有效性 ,
 code (string, optional): 编号 ,
 description (string, optional): 类别描述 ,
 id (integer, optional): 主键ID ,
 level (integer, optional): 分类级别 ,
 name (string, optional): 分类名称 ,
 parentId (integer, optional): 上级分类id ,
 attachId(integer):图片上传后返回的id
 }
 * */
export function categoryModify(param) {
	return request(`${config.server}/api/v1/dms/category/update`,{
		method: 'post',
		body: param
	});
}


//新增分类
/*
 * {
 active (integer, optional): 有效性 ,
 code (string, optional): 编号 ,
 description (string, optional): 类别描述 ,
 level (integer, optional): 分类级别 ,
 name (string, optional): 分类名称 ,
 parentId (integer, optional): 上级分类id ,
 attachId(integer):图片上传后返回的id
 }
 * */
export function categoryAdd(param) {
	return request(`${config.server}/api/v1/dms/category/save`,{
		method: 'post',
		body: param
	});
}


//失效分类--传id+active
export function categoryInvalid(param) {
	return request(`${config.server}/api/v1/dms/category/invalid?${objectSerial(param)}`,{
		method: 'post',
		body: param
	});
}

//获取树形图
export function categoryTree(param) {
	return request(`${config.server}/api/v1/dms/category/listTree?${objectSerial(param)}`);
}


//删除分类
export function categoryDelete(param) {
	return request(`${config.server}/api/v1/dms/category/delete?${objectSerial(param)}`,{method: 'post'});
}


//查询子分类--传父id
export function childrenCategory(param) {
	return request(`${config.server}/api/v1/dms/category/listTree?${objectSerial(param)}`,{method: 'post'});
}


//获取详情--传父id
export function categoryDetail(param) {
	return request(`${config.server}/api/v1/dms/category/detail?${objectSerial(param)}`);
}

//获取最大级别，传空
export function categoryLevel(param) {
	return request(`${config.server}/api/v1/dms/category/getLevelMax?${objectSerial(param)}`);
}


// WEBPACK FOOTER //
// ./src/service/category/index.js